module.exports = __webpack_public_path__ + "static/media/alfa2.c6facbf8.jpg";